import styles from './Security.module.css';
import '../../resources/css/admin_style.css';
import React, {useEffect, useRef, useState, useContext} from "react";
import { AuthContext } from "../../utils/contextapi/AuthProvider";
import { OAUTH } from "../../utils/Config";
import axios from "../../utils/api/axios";
import SecurityPanel from './commponet/SecurityPanel';
import LoginLogPanel from './commponet/LoginLogPanel';

/**
 * 보안
 * @param callback
 * @param delay
 */

function Security({ setMovePage }) {
    const [userData, setUserData] = useState(null);

    const {
        saveUser,
        saveRole,
        user
    } = useContext(AuthContext);

    // 최초 로딩 여부
    const isFirstLoadRef = useRef(true);

    // 사용자 정보 로딩 함수
    const loadUser = async (isUpdate = false) => {
        if (isUpdate) {
            axios.get(OAUTH + "/userinfo").then((res) => {
              const data = res.data;
              const roles = Array.isArray(data.roles) ? data.roles.filter(Boolean) : ["USER"];

              saveUser(data);
              saveRole(roles);
            //   sessionStorage.setItem("user", JSON.stringify(data));
            //   sessionStorage.setItem("roles", JSON.stringify(roles));
          });
        } else {

        }
        
        const stored = user;
        if (stored) setUserData(JSON.parse(stored));
    };

    useEffect(() => {
        // setMovePage("account/manage");
    }, []);

    return (
        <div className={styles.layoutWrapper}>
            <h3>보안</h3>  
            <div className={styles.contentsWrapper}>
                <div className={styles.accountContent}>
                    <div className={styles.infoCard}>
                        <SecurityPanel  />
                    </div>
                </div>

                <div className={styles.accountContent}>
                    <div className={styles.infoCard}>
                        <LoginLogPanel  />
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Security;